<div class="date-range-picker-mobile-modal">
  <div class="date-range-picker-mobile-modal-header">
    <div class="date-range-picker-mobile-modal-header__title">
      {{ headerTitle }}
    </div>
    <div
      class="date-range-picker-mobile-modal-header__close"
      (click)="onCloseClick()"
    >
      <app-svg-icon
        icon="close"
        stroke="gray-content-primary"
        [width]="12"
        [height]="12">
      </app-svg-icon>
    </div>
  </div>

  <div class="date-range-picker-mobile-modal-content">
    <cdk-virtual-scroll-viewport itemSize="10">
      <div
        *cdkVirtualFor="let month of months$ | async; let i = index"
        class="date-range-picker-mobile-modal-content__item"
      >
        <app-date-range-picker-month
          [month]="month"
        ></app-date-range-picker-month>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <div class="date-range-picker-mobile-modal-footer">
    <button
      class="date-range-picker-mobile-modal-footer__button-confirm"
      (click)="onConfirmClick()"
    >
      {{ confirmButtonText }}
    </button>
    @if (withSkip) {
      <button
        class="date-range-picker-mobile-modal-footer__button-skip"
        (click)="onSkipClick()"
      >
        {{ skipButtonText }}
      </button>
    }
  </div>
</div>
